export default "__VITE_ASSET__D9yEmY$I__"